<template lang="pug">
    div(:style="'min-height:'+h")
        div.px-0.white.detail-head
            el-row.pl-5
                el-col(:span="8")
                    Breadcrumb
            el-tabs.title(v-model="activeName" @tab-click="handleTabClick")
                el-tab-pane(:label="'执行中('+count1+')'" name="first")
                el-tab-pane(:label="'已终止('+count2+')'" name="second")
        div(style="height:110px")
        el-main.white.pa-3.ma-4
            el-row.py-3(v-if="!flag" type="flex" justify="center")
                el-col(:span="13")
                    el-row(type="flex" justify="center" :gutter="10")
                        el-col(:span="13")
                            el-input.w-100(v-model="list.key_name" placeholder="请输入合同名称/合同档案编号" clearable)
                        el-col(:span="11")
                            el-button(type="primary" @click="search(1)" :loading="loading") 查询
                            el-button(type="text" @click="flag = true" :loading="loading") 高级搜索
            div(v-else)
                el-row.py-3(type="flex" justify="center")
                    el-col(:span="22")
                        el-row(type="flex" justify="center" :gutter="10")
                            el-col(:span="6")
                                el-input.w-100(v-model="list.name" placeholder="合同名称" clearable)
                            el-col(:span="6")
                                el-input.w-100(v-model="list.code" placeholder="合同档案编号" clearable)
                            el-col(:span="6")
                                el-input.w-100(v-model="list.material_info" placeholder="物料" clearable)
                el-row.py-2(type="flex" justify="center")
                    el-col(:span="22")
                        el-row(type="flex" justify="center" :gutter="10")
                            el-col(:span="6")
                                el-select.w-100(v-model="list.pk_org" :filter-method="sourcebuyorg" filterable placeholder="采购组织")
                                    el-option(v-for="item in buyorg" :key="item.pk_org" :label="item.name" :value="item.pk_org")
                            el-col(:span="6")
                            el-col(:span="6")
                el-row.py-1(type="flex" justify="center")
                    el-col(:span="12")
                        el-row(type="flex" justify="center")
                            el-col(:span="10")
                                el-button(type="primary" @click="search(2)" :loading="loading") 查询
                                el-button(@click="clear") 清空
                                el-button(type="text" @click="flag = false" :loading="loading") 收起
            el-table(:data="data" v-loading="loading" size="mini")
                el-table-column(prop="code" label="合同档案编号" show-overflow-tooltip)
                el-table-column(prop="name" label="合同名称" show-overflow-tooltip)
                el-table-column(prop="active_time" label="生效日期" width="120")
                el-table-column(prop="material_info" label="物料" show-overflow-tooltip)
                el-table-column(prop="org_name" label="采购组织" show-overflow-tooltip)
                el-table-column(prop="total_money" label="总金额(元)" width="120")
                el-table-column(prop="status_name" label="合同状态" width="100")
                el-table-column(label="操作" width="100")
                    template(slot-scope="scope")
                        el-button(v-if="user.role == 3 ? true : ops.indexOf('details') > -1" size="mini" type="primary" plain @click="goto('/supply/sales_contract_detail/'+scope.row.id)") 详情
            el-pagination.my-4.text-center(@size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="list.page_num" :page-sizes="page_sizes" :page-size="list.page_size" layout="total,sizes, prev, pager, next, jumper" :total="count" background)
</template>
<script>
    export default {
        data() {
            return {
                flag: false,
                h: "",
                loading: false,
                activeName: "first",
                list: {
                    is_so: 1,
                    key_name: null,
                    code: null,
                    name: null,
                    material_info: null,
                    pk_org: null,
                    status: 2,
                    page_num: 1,
                    page_size: 10,
                },
                count: 0,
                count1: 0,
                count2: 0,
                list1: {
                    status: 2,
                    page_num: 1,
                    page_size: 10,
                },
                list2: {
                    status: 3,
                    page_num: 1,
                    page_size: 10,
                },
                data: [],
            };
        },
        methods: {
            clear() {
                this.list.code = null;
                this.list.name = null;
                this.list.material_info = null;
                this.list.pk_org = null;
            },
            search(type) {
                if (type == 2) {
                    this.list.key_name = null;
                } else {
                    this.list.code = null;
                    this.list.material_info = null;
                    this.list.name = null;
                    this.list.pk_org = null;
                }
                this.list.page_num = 1;
                this.$router.push({
                    path: this.$route.path,
                    hash: this.$route.hash,
                    query: this.list,
                });
            },
            handleSizeChange(e) {
                this.list.page_size = e;
                this.$router.push({
                    path: this.$route.path,
                    hash: this.$route.hash,
                    query: this.list,
                });
            },
            handleCurrentChange(e) {
                this.list.page_num = e;
                this.$router.push({
                    path: this.$route.path,
                    hash: this.$route.hash,
                    query: this.list,
                });
            },
            handleTabClick(tab) {
                let data = this.list;
                if (tab.name == "first") {
                    data.page_size = this.list1.page_size;
                    data.page_num = this.list1.page_num;
                    data.status = this.list1.status;
                } else if (tab.name == "second") {
                    data.page_size = this.list2.page_size;
                    data.page_num = this.list2.page_num;
                    data.status = this.list2.status;
                }
                this.$router.push({
                    path: this.$route.path,
                    hash: "#" + tab.name,
                    query: data,
                });
            },
            async getList() {
                this.loading = true;
                let res = await this.$api.purchase_contract.getList(this.list);
                this.loading = false;
                if (res) {
                    this.data = res.data;
                    this.count1 = res.count4 ? res.count4 : 0;
                    this.count2 = res.count5 ? res.count5 : 0;
                    switch (this.activeName) {
                        case "first":
                            this.count = this.count1;
                            break;
                        case "second":
                            this.count = this.count2;
                            break;
                        default:
                            break;
                    }
                }
            },
            initList() {
                let data = this.$route.query;
                if (JSON.stringify(data) != "{}") {
                    this.list = this.$utils.cloneDeep(data);
                    if (data.page_num) {
                        this.list.page_num = parseInt(data.page_num);
                    }
                    if (data.page_size) {
                        this.list.page_size =
                            this.page_sizes.indexOf(parseInt(data.page_size)) > -1
                                ? parseInt(data.page_size)
                                : this.page_sizes[0];
                    }
                    if (
                        this.list.code ||
                        this.list.material_info ||
                        this.list.name ||
                        this.list.pk_org
                    ) {
                        this.flag = true;
                    }
                } else {
                    this.list.status = this.list1.status;
                }
                let status = this.list.status;
                switch (parseInt(status)) {
                    case 2:
                        this.activeName = "first";
                        break;
                    default:
                        this.list.status = 3;
                        this.activeName = "second";
                        break;
                }
                switch (this.activeName) {
                    case "first":
                        this.list1.page_size = this.list.page_size;
                        this.list1.page_num = this.list.page_num;
                        break;
                    case "second":
                        this.list2.page_size = this.list.page_size;
                        this.list2.page_num = this.list.page_num;
                        break;
                    default:
                        break;
                }
                this.$router.push({
                    path: this.$route.path,
                    hash: "#" + this.activeName,
                    query: this.list,
                });
            },
            init() {
                this.activeName = this.$route.hash
                    ? this.$route.hash.split("#")[1]
                    : "first";
                this.initList();
                this.getList();
            },
        },
        mounted() {
            this.h = document.body.clientHeight - 61 + "px";
        },
        created() {
            if (
                this.$store.state.token &&
                JSON.stringify(this.$store.state.material_class) == "{}"
            )
                this.getMaterialClass();
            if (this.$store.state.token && this.$store.state.purchase_org == false)
                this.getPurchaseOrg();
            if (this.$store.state.token && this.$store.state.stock_org == false)
                this.getStockOrg();
        },
        watch: {
            $route: {
                handler: "init",
                immediate: true,
            },
        },
    };
</script>